var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-prism-editor',{staticClass:"prism-editor",style:({ height: _vm.height }),attrs:{"highlight":_vm.highlighter,"line-numbers":_vm.lineNumbers},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }